// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Onboarding_onboarding__FNlxO {
	/* overflow-y: scroll; */
	padding-top: 81px;
	/* height: 100vh; */
}

.Onboarding_stepCon__YWt9z {
	gap: 14px;
}

.Onboarding_stepMarkCon__7Itrj {
	display: flex;
	width: 40px;
	height: 40px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 50%;
	background: linear-gradient(to bottom, #34c991, #34c991), #fff;
}

.Onboarding_bigStepMarkCon__Eei-r {
	width: 63px !important;
	height: 63px !important;
	margin-bottom: 37px;
}

.Onboarding_stepMark__TE9qt {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Onboarding_bigStepMark__PTIA1 {
	width: 31px !important;
	height: 31px !important;
	flex-shrink: 0;
}

.Onboarding_step__Ohals {
	color: #4e4e4e;
	width: 40px;
	height: 40px;
	border-width: 2px;
	border-color: #e0e0e9;
	border-style: solid;
	border-radius: 50%;
	text-align: center;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 19.714px */
}

.Onboarding_currentStep__1WLeJ {
	color: #052E26 !important;
	border-color: #052E26 !important;
	background: linear-gradient(to bottom, #052E261a, #052E261a), #fff !important;
}

.Onboarding_tag__j-bfn {
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 109.523%; /* 17.524px */
}

.Onboarding_currentTag__-bRvt {
	color: #000 !important;
}

.Onboarding_stepsCon__x7x8n {
	background-color: #fff;
	position: fixed;
	top: 90px;
	left: 0;
	z-index: 1000;
}

.Onboarding_stepsWrapper__wT-rI {
	gap: 30px;
	padding: 20px 0;
	border-bottom: 1px solid #e4e4e6;
}

.Onboarding_underTheme__jWkoW {
	color: #494747;
	font-family: Manrope;
	font-size: 16px;
	margin-top: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 125%; /* 20px */
}

.Onboarding_onboardingProgress__XpgyN {
	height: 5px;
	flex-shrink: 0;
	background: rgba(242, 190, 21, 0.2);
}

.Onboarding_progressCon2__4MjHW {
	border: none;
	height: 100%;
	padding: 0 !important;
}

.Onboarding_progressBarCon__ekoVN {
	height: 100%;
	position: relative;
	overflow: hidden;
}

.Onboarding_progressBarComplete2__VL5EZ {
	height: 100%;
	position: absolute;
	top: 0;
	right: 100%;
	transition: right 1.5s;
	background: #f2be15;
}

.Onboarding_onboardingWrapper__Q8fZR {
	padding-top: 50px;
}

.Onboarding_fileUploader__QVQg5 {
}

.Onboarding_fileFieldCon__KCD3s {
}

.Onboarding_fileFieldTitle__gl1UB {
	list-style-position: inside;
	padding: 0 10px;
	color: #000;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 36px; /* 225% */
}

.Onboarding_fieldTitle__vT3Ho {
}

.Onboarding_rememberLabel__tj7\\+s {
	padding: 0 10px;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
	.Onboarding_tag__j-bfn:not(.Onboarding_currentTag__-bRvt) {
		display: none !important;
	}

	.Onboarding_stepsWrapper__wT-rI {
		gap: 10px;
	}

	.Onboarding_onboardingWrapper__Q8fZR {
		padding-top: 25px;
	}
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) {
	.Onboarding_tag__j-bfn:not(.Onboarding_currentTag__-bRvt) {
		display: none !important;
	}

	.Onboarding_stepsWrapper__wT-rI {
		gap: 10px;
	}

	.Onboarding_onboardingWrapper__Q8fZR {
		padding-top: 25px;
	}

	.Onboarding_onboarding__FNlxO {
		padding-top: 113px !important;
	}
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.Onboarding_underTheme__jWkoW {
		color: #494747;
		font-family: Manrope;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 125%; /* 15px */
	}

	.Onboarding_fileFieldTitle__gl1UB {
		color: #000;
		font-family: Manrope;
		font-size: 13px;
		font-style: normal;
		font-weight: 500;
		line-height: 36px; /* 276.923% */
	}

	.Onboarding_onboarding__FNlxO {
		padding-top: 113px !important;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Onboarding.module.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,8DAA8D;AAC/D;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,6EAA6E;AAC9E;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,SAAS;CACT,OAAO;CACP,aAAa;AACd;;AAEA;CACC,SAAS;CACT,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,WAAW;CACX,cAAc;CACd,mCAAmC;AACpC;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;AACA;;AAEA;CACC,eAAe;AAChB;;AAEA,yDAAyD;AACzD;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;CAC7B;;CAEA;EACC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;CACjC;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".onboarding {\n\t/* overflow-y: scroll; */\n\tpadding-top: 81px;\n\t/* height: 100vh; */\n}\n\n.stepCon {\n\tgap: 14px;\n}\n\n.stepMarkCon {\n\tdisplay: flex;\n\twidth: 40px;\n\theight: 40px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n\tborder-radius: 50%;\n\tbackground: linear-gradient(to bottom, #34c991, #34c991), #fff;\n}\n\n.bigStepMarkCon {\n\twidth: 63px !important;\n\theight: 63px !important;\n\tmargin-bottom: 37px;\n}\n\n.stepMark {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.bigStepMark {\n\twidth: 31px !important;\n\theight: 31px !important;\n\tflex-shrink: 0;\n}\n\n.step {\n\tcolor: #4e4e4e;\n\twidth: 40px;\n\theight: 40px;\n\tborder-width: 2px;\n\tborder-color: #e0e0e9;\n\tborder-style: solid;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 19.714px */\n}\n\n.currentStep {\n\tcolor: #052E26 !important;\n\tborder-color: #052E26 !important;\n\tbackground: linear-gradient(to bottom, #052E261a, #052E261a), #fff !important;\n}\n\n.tag {\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 109.523%; /* 17.524px */\n}\n\n.currentTag {\n\tcolor: #000 !important;\n}\n\n.stepsCon {\n\tbackground-color: #fff;\n\tposition: fixed;\n\ttop: 90px;\n\tleft: 0;\n\tz-index: 1000;\n}\n\n.stepsWrapper {\n\tgap: 30px;\n\tpadding: 20px 0;\n\tborder-bottom: 1px solid #e4e4e6;\n}\n\n.underTheme {\n\tcolor: #494747;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tmargin-top: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 125%; /* 20px */\n}\n\n.onboardingProgress {\n\theight: 5px;\n\tflex-shrink: 0;\n\tbackground: rgba(242, 190, 21, 0.2);\n}\n\n.progressCon2 {\n\tborder: none;\n\theight: 100%;\n\tpadding: 0 !important;\n}\n\n.progressBarCon {\n\theight: 100%;\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.progressBarComplete2 {\n\theight: 100%;\n\tposition: absolute;\n\ttop: 0;\n\tright: 100%;\n\ttransition: right 1.5s;\n\tbackground: #f2be15;\n}\n\n.onboardingWrapper {\n\tpadding-top: 50px;\n}\n\n.fileUploader {\n}\n\n.fileFieldCon {\n}\n\n.fileFieldTitle {\n\tlist-style-position: inside;\n\tpadding: 0 10px;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 36px; /* 225% */\n}\n\n.fieldTitle {\n}\n\n.rememberLabel {\n\tpadding: 0 10px;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n\t.tag:not(.currentTag) {\n\t\tdisplay: none !important;\n\t}\n\n\t.stepsWrapper {\n\t\tgap: 10px;\n\t}\n\n\t.onboardingWrapper {\n\t\tpadding-top: 25px;\n\t}\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) {\n\t.tag:not(.currentTag) {\n\t\tdisplay: none !important;\n\t}\n\n\t.stepsWrapper {\n\t\tgap: 10px;\n\t}\n\n\t.onboardingWrapper {\n\t\tpadding-top: 25px;\n\t}\n\n\t.onboarding {\n\t\tpadding-top: 113px !important;\n\t}\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.underTheme {\n\t\tcolor: #494747;\n\t\tfont-family: Manrope;\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 125%; /* 15px */\n\t}\n\n\t.fileFieldTitle {\n\t\tcolor: #000;\n\t\tfont-family: Manrope;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 36px; /* 276.923% */\n\t}\n\n\t.onboarding {\n\t\tpadding-top: 113px !important;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"onboarding": `Onboarding_onboarding__FNlxO`,
	"stepCon": `Onboarding_stepCon__YWt9z`,
	"stepMarkCon": `Onboarding_stepMarkCon__7Itrj`,
	"bigStepMarkCon": `Onboarding_bigStepMarkCon__Eei-r`,
	"stepMark": `Onboarding_stepMark__TE9qt`,
	"bigStepMark": `Onboarding_bigStepMark__PTIA1`,
	"step": `Onboarding_step__Ohals`,
	"currentStep": `Onboarding_currentStep__1WLeJ`,
	"tag": `Onboarding_tag__j-bfn`,
	"currentTag": `Onboarding_currentTag__-bRvt`,
	"stepsCon": `Onboarding_stepsCon__x7x8n`,
	"stepsWrapper": `Onboarding_stepsWrapper__wT-rI`,
	"underTheme": `Onboarding_underTheme__jWkoW`,
	"onboardingProgress": `Onboarding_onboardingProgress__XpgyN`,
	"progressCon2": `Onboarding_progressCon2__4MjHW`,
	"progressBarCon": `Onboarding_progressBarCon__ekoVN`,
	"progressBarComplete2": `Onboarding_progressBarComplete2__VL5EZ`,
	"onboardingWrapper": `Onboarding_onboardingWrapper__Q8fZR`,
	"fileUploader": `Onboarding_fileUploader__QVQg5`,
	"fileFieldCon": `Onboarding_fileFieldCon__KCD3s`,
	"fileFieldTitle": `Onboarding_fileFieldTitle__gl1UB`,
	"fieldTitle": `Onboarding_fieldTitle__vT3Ho`,
	"rememberLabel": `Onboarding_rememberLabel__tj7+s`
};
export default ___CSS_LOADER_EXPORT___;
